import constants from "./constants";

export const signedUserData = () => {
	const user = localStorage.getItem(constants.STORAGE_SIGNED_USER_KEY);
	return user;
};

export const isAdmin = () => {
	const user = JSON.parse(signedUserData());
	return user && user.type === 'a';
};

export const isSandbox = () => {
	const user = JSON.parse(signedUserData());
	return user && user.onsandbox && user.onsandbox === true;
};

